import * as React from "react";
import Modal from "@material-ui/core/Modal";
import {
  Col,
  Button,
  Row,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import AlertModal from "../../../../shared/components/Modal";
import DigitalSignature from "../../../DigitalSignature/DigitalSignature";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileSignature } from "@fortawesome/free-solid-svg-icons";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InformedConsentPDF from "./InformedConsentPDF";

const InformedConsent = ({ data, closeModalInformedConsent, opened }) => {
  //Consentimiento Informado
  const [textInformedConsent, setInformedConsent] = React.useState(null);
  const [disabledText, setDisabledText] = React.useState(false);
  const [dataPDF, setDataPDF] = React.useState(null);

  //Firmas
  const [patientSignature, setPatientSignature] = React.useState(null);
  const [firstWitnessSignature, setFirstWitnessSignature] =
    React.useState(null);
  const [secondWitnessSignature, setSecondWitnessSignature] =
    React.useState(null);

  //Modal Firmas
  const [openSignaturePatient, setOpenSignaturePatient] = React.useState(null);
  const [openFirstWitnessSignature, setOpenFirstWitnessSignature] =
    React.useState(null);
  const [openSecondWitnessSignature, setOpenSecondWitnessSignature] =
    React.useState(null);

  //Alerta Modal
  const [colorAlertModal, setColorAlertModal] = React.useState("");
  const [messagAlerteModal, setMessageAlertModal] = React.useState(null);
  const [showAlertModal, setShowAlertModal] = React.useState(false);

  //PDF
  const [openModalPDF, setOpenModalPDF] = React.useState(null);

  //lista de consentimientos
  const [listConsentimientos, setListConsentimientos] = React.useState([]);
  const [activeTab, setActiveTab] = React.useState("1");
  const [idClinica] = React.useState(sessionStorage.getItem("id_clinica"));
  const [consentimiento, setConsentimiento] = React.useState([]);

  React.useEffect(() => {
    getInformedConsent();
  }, []);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const getTemplatesData = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "historia-plantillas/consultar?id_clinica=" +
          sessionStorage.getItem("id_clinica"),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      );
      const dataResponse = await response.json();
      const arrayConsentimientosServicio = await loadConsentimientoInformado(
        data.servicios[0].id_servicio
      );
      
      if (dataResponse.plantilla.consentimiento_informado !== null) {
        const arraysPlantillaConsentimiento =
          dataResponse.plantilla.consentimiento_informado
            .consentimiento_informado;
            
        const joinConsentimiento = arrayConsentimientosServicio.map((item) => {
          const encontrado = arraysPlantillaConsentimiento.find(
            (consent) => consent.id === item.id
          );
          return {
            id: item.id,
            titulo: item.titulo,
            contenido: encontrado ? encontrado.contenido : null,
          };
        });
        const arrayConsentimientosReplace = joinConsentimiento.map(
          (plantilla) => {
            let plantillaConsentimiento = plantilla.contenido.toString();
            let clinica = JSON.parse(sessionStorage.getItem("clinica"));
            let localidad = JSON.parse(sessionStorage.getItem("localidad"));
            let localidadReplace =
              clinica.direccion.direccion +
              " - " +
              localidad.ciudad +
              "," +
              localidad.dpto;
            plantillaConsentimiento = plantillaConsentimiento.replace(
              "{paciente}",
              data?.fullname
            );
            plantillaConsentimiento = plantillaConsentimiento.replace(
              "{procedimiento}",
              data?.servicios[0].nombre
            );
            plantillaConsentimiento = plantillaConsentimiento.replace(
              "{tipo_identidad}",
              data?.tip_documento
            );
            plantillaConsentimiento = plantillaConsentimiento.replace(
              "{identidad}",
              data?.num_documento
            );
            plantillaConsentimiento = plantillaConsentimiento.replace(
              "{empresa}",
              clinica.nombre
            );
            plantillaConsentimiento = plantillaConsentimiento.replace(
              "{profesional}",
              data?.nombre_profesional !== null &&
                data?.nombre_profesional !== undefined
                ? data?.nombre_profesional.toUpperCase()
                : data?.profesional.toUpperCase()
            );
            plantillaConsentimiento = plantillaConsentimiento.replace(
              "{direccion}",
              localidadReplace
            );
            return {
              id: plantilla.id,
              titulo: plantilla.titulo,
              contenido: plantillaConsentimiento,
            };
          }
        );
        
        setInformedConsent({consentimiento: arrayConsentimientosReplace});
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadConsentimientoInformado = async (id_servicio) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "servicio/consultar?id_servicio=",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify({ id_servicio }),
        }
      );
      if (response.status != 500 && response.status != 403) {
        const dataServicio = await response.json();
        return dataServicio.contenido[0].formato_consentimiento
          .formato_consentimiento;
      } else {
        throw new Error(
          "Ha ocurrido un error cargando el consentimiento informado, es posible que no se halla diligenciado"
        );
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getInformedConsent = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision-consentimiento-informado/consultar?id_admision=" +
        data.id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(
            "Ha ocurrido un error cargando el consentimiento informado, es posible que no se halla diligenciado"
          );
        }
      })
      .then((data) => {
        if (
          data.consentimiento_informado != null &&
          data.consentimiento_informado != undefined
        ) {
          setInformedConsent(data.consentimiento_informado.consentimiento);

          //Recoleccion de Firmas
          let dataConsentimientoInformado = data.consentimiento_informado;
          dataConsentimientoInformado.firma_paciente = null;
          dataConsentimientoInformado.firma_primer_testigo = null;
          dataConsentimientoInformado.firma_segundo_testigo = null;

          if (
            dataConsentimientoInformado.firma_doctor != null &&
            dataConsentimientoInformado.firma_doctor != undefined
          ) {
            dataConsentimientoInformado.firma_doctor =
              process.env.REACT_APP_PUBLIC_URL +
              dataConsentimientoInformado.firma_doctor +
              "/" +
              sessionStorage.getItem("token");
          }

          if (
            dataConsentimientoInformado.firma_tecnologo != null &&
            dataConsentimientoInformado.firma_tecnologo != undefined
          ) {
            dataConsentimientoInformado.firma_tecnologo =
              process.env.REACT_APP_PUBLIC_URL +
              dataConsentimientoInformado.firma_tecnologo +
              "/" +
              sessionStorage.getItem("token");
          }

          if (data.consentimiento_informado.firmas_digitales) {
            let firmasDigitalesConsentimiento =
              data.consentimiento_informado.firmas_digitales.firmas.filter(
                (fir) => fir != null
              );

            let firmaPaciente = firmasDigitalesConsentimiento.find(
              (fir) => fir.autor == "paciente"
            );
            if (firmaPaciente != undefined && firmaPaciente != null) {
              let firma =
                process.env.REACT_APP_PUBLIC_URL +
                firmaPaciente.url_file_firma +
                sessionStorage.getItem("token");
              setPatientSignature(firma);
              dataConsentimientoInformado.firma_paciente = firma;
            }

            let firmaPrimerTestigo = firmasDigitalesConsentimiento.find(
              (fir) => fir.autor == "primer_testigo"
            );
            if (firmaPrimerTestigo != undefined && firmaPrimerTestigo != null) {
              let firma =
                process.env.REACT_APP_PUBLIC_URL +
                firmaPrimerTestigo.url_file_firma +
                sessionStorage.getItem("token");
              setFirstWitnessSignature(firma);
              dataConsentimientoInformado.firma_primer_testigo = firma;
            }

            let firmaSegundoTestigo = firmasDigitalesConsentimiento.find(
              (fir) => fir.autor == "segundo_testigo"
            );
            if (
              firmaSegundoTestigo != undefined &&
              firmaSegundoTestigo != null
            ) {
              let firma =
                process.env.REACT_APP_PUBLIC_URL +
                firmaSegundoTestigo.url_file_firma +
                sessionStorage.getItem("token");
              setSecondWitnessSignature(firma);
              dataConsentimientoInformado.firma_segundo_testigo = firma;
            }
          }

          setDisabledText(true);
          setDataPDF(dataConsentimientoInformado);
        } else {
          getTemplatesData();
        }
      })
      .catch((err) => {
        console.log(err);
        getTemplatesData();
      });
  };

  const saveInformedConsent = async () => {
    let dataSend = {
      id_admision: data.id_admision,
      html_consentimiento: textInformedConsent,
      firma_paciente: patientSignature,
      firma_primer_testigo: firstWitnessSignature,
      firma_segundo_testigo: secondWitnessSignature,
    };

    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision-consentimiento-informado/create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el servidor");
        }
      })
      .then((data) => {
        alertModalOpen(
          "success",
          "Consentimiento Informado Generado con exito"
        );
      })
      .catch((err) => {
        console.log(err);
        alertModalOpen(
          "danger",
          "Ha ocurrido un error generando el Consentimiento Informado"
        );
      });
  };

  const validateInformedConsent = () => {
    if (textInformedConsent == null) {
      alertModalOpen(
        "danger",
        "No puede generar un consentimiento informado sin minimo describir la situación del Procedimiento"
      );
      return;
    }

    if (patientSignature == null) {
      alertModalOpen(
        "danger",
        "No puede generar un consentimiento informado sin la firma del Paciente"
      );
      return;
    }

    alertModalOpen(
      "warning",
      "Esta seguro que desea generar el Consentimiento Informado"
    );
  };

  const onOkAlertModal = () => {
    switch (colorAlertModal) {
      case "warning":
        saveInformedConsent();
        break;
      case "success":
        cleanAlertModal();
        closeModalInformedConsent();
        break;
      case "danger":
        cleanAlertModal();
        break;
    }
  };

  const alertModalOpen = (color, message) => {
    setColorAlertModal(color);
    setMessageAlertModal(message);
    setShowAlertModal(true);
  };

  const cleanAlertModal = () => {
    setColorAlertModal("");
    setMessageAlertModal("");
    setShowAlertModal(false);
  };

  const printPDFInformedConsent = () => {
    if (dataPDF != null && dataPDF != undefined) {
      setOpenModalPDF(true);
      InformedConsentPDF(dataPDF);
    }
  };

  const handleContent = (data, informedConsent) => {
    const newArray = textInformedConsent?.consentimiento?.map((consent) => {
      if (consent.id === informedConsent.id) {
        return { ...consent, contenido: data };
      }
      return consent;
    });
    setInformedConsent({ consentimiento: newArray });
  };

  return (
    <div>
      <Modal
        open={opened}
        onClose={(e) => {
          closeModalInformedConsent();
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
        disableEnforceFocus={true}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "100%", margin: 10 }}
        >
          <div>
            <div className="card__title">
              <h5 className="bold-text">Consentimiento Informado</h5>
            </div>
            <Nav tabs>
              {textInformedConsent?.consentimiento?.map((informedConsent, index) => (
                <NavItem key={index}>
                  <NavLink
                    className={
                      activeTab === (index + 1).toString() ? "active" : ""
                    }
                    onClick={() => toggle((index + 1).toString())}
                  >
                    {informedConsent.titulo}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={activeTab}>
              {textInformedConsent?.consentimiento?.map((informedConsent, index) => (
                <TabPane tabId={`${index + 1}`} key={index}>
                  <div
                    style={{
                      margin: 10,
                      maxHeight: "350px",
                      overflowY: "scroll",
                    }}
                  >
                    <CKEditor
                      style={{
                        width: "100%",
                        height: "300px",
                        maxHeight: "300px",
                      }}
                      editor={ClassicEditor}
                      disabled={disabledText}
                      data={informedConsent.contenido}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        handleContent(data, informedConsent);
                      }}
                    />
                  </div>
                </TabPane>
              ))}
            </TabContent>
            <br />
            <Container>
              <Row>
                <Col md={4}>
                  <div className="text-center">
                    <Button
                      style={{ marginTop: 10, marginRight: 10 }}
                      variant="contained"
                      color="primary"
                      className="btn btn-sm"
                      disabled={disabledText}
                      onClick={() => {
                        setOpenSignaturePatient(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faFileSignature} /> Firma del Paciente
                    </Button>
                    {patientSignature != null ? (
                      <img
                        style={{ width: 200, height: 60 }}
                        src={patientSignature}
                      />
                    ) : null}
                    <DigitalSignature
                      openModalSignature={openSignaturePatient}
                      closeModalSignature={() => setOpenSignaturePatient(false)}
                      confirmSign={(value) => {
                        setPatientSignature(value);
                      }}
                      signature={patientSignature}
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <div className="text-center">
                    <Button
                      style={{ marginTop: 10, marginRight: 10 }}
                      variant="contained"
                      color="primary"
                      disabled={disabledText}
                      className="btn btn-sm"
                      onClick={() => {
                        setOpenFirstWitnessSignature(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faFileSignature} /> Firma Primer
                      Testigo
                    </Button>
                    {firstWitnessSignature != null ? (
                      <img
                        style={{ width: 200, height: 60 }}
                        src={firstWitnessSignature}
                      />
                    ) : null}
                    <DigitalSignature
                      openModalSignature={openFirstWitnessSignature}
                      closeModalSignature={() =>
                        setOpenFirstWitnessSignature(false)
                      }
                      confirmSign={(value) => {
                        setFirstWitnessSignature(value);
                      }}
                      signature={firstWitnessSignature}
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <div className="text-center">
                    <Button
                      style={{ marginTop: 10, marginRight: 10 }}
                      variant="contained"
                      color="primary"
                      className="btn btn-sm"
                      disabled={disabledText}
                      onClick={() => {
                        setOpenSecondWitnessSignature(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faFileSignature} /> Firma Segundo
                      Testigo
                    </Button>
                    {secondWitnessSignature != null ? (
                      <img
                        style={{ width: 200, height: 60 }}
                        src={secondWitnessSignature}
                      />
                    ) : null}
                    <DigitalSignature
                      openModalSignature={openSecondWitnessSignature}
                      closeModalSignature={() =>
                        setOpenSecondWitnessSignature(false)
                      }
                      confirmSign={(value) => {
                        setSecondWitnessSignature(value);
                      }}
                      signature={secondWitnessSignature}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
            <br />
            <br />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <Button
              className="btn btn-sm"
              onClick={() => {
                closeModalInformedConsent();
              }}
            >
              Cerrar
            </Button>

            {dataPDF != null ? (
              <Button
                color="primary"
                className="btn btn-sm"
                onClick={() => {
                  printPDFInformedConsent();
                }}
              >
                Imprimir
              </Button>
            ) : (
              <Button
                color="primary"
                disabled={disabledText}
                className="btn btn-sm"
                onClick={() => {
                  validateInformedConsent();
                }}
              >
                Guardar Consentimiento Informado
              </Button>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        open={openModalPDF}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "120%", margin: 10 }}
        >
          <IconButton
            style={{ float: "right" }}
            onClick={() => {
              setOpenModalPDF(false);
            }}
          >
            <CloseIcon />
          </IconButton>
          <iframe id="pdfV" width="1000" height="600"></iframe>
        </div>
      </Modal>

      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => {
          onOkAlertModal();
        }}
        toggle={() => {
          cleanAlertModal();
        }}
      />
    </div>
  );
};
export default InformedConsent;
